"use strict";
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionFailed = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
const ConnectionFailed = ({ size = 16, fill, title = "Connection Failed", ...rest }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Base_1.Base, { size: size, fill: fill !== null && fill !== void 0 ? fill : theme.icon, ...rest },
        react_1.default.createElement("title", null, title),
        react_1.default.createElement("path", { fill: "#FF626D", d: "M13.9,12.5L16,14.6 14.6,16 12.5,13.9 10.3,16 8.9,14.6 11,12.5 8.9,10.4 10.3,9 12.4,11.1 14.5,9 15.9,10.4 13.9,12.5z" }),
        react_1.default.createElement("path", { d: "M7,14.8L7,15C7,15.7 6.6,16 5.9,16 5.2,16 5,15.7 5,15L5,13 3,12 2,11 2,8 0.7,8C0.4,8,0,7.9,0,7.6L0,5.3C0,5,0.7,5,1,5L2,5 2,1C2,0.3 2.6,0 3.3,0 3.7,0 4,-0.2 4,1L4,4 8,4 8,1C8.1,0.3 8,0 8.7,0 9,0 9.9,-0.2 10,1L10,5 11,5C11.3,5,12,5.1,12,5.3L12,7.3C12,7.5,11.7,7.8,11.5,7.9L10.4,6.8 6.9,10.3 8.7,12.1 7,13 7,14.4 6.8,14.6 7,14.8z" })));
};
exports.ConnectionFailed = ConnectionFailed;
exports.default = exports.ConnectionFailed;
//# sourceMappingURL=Disconnected.js.map